import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, Badge, EmptyState, ConfirmDialog } from '../../components/ui';
import { fmt, errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function Backorders() {
  const { data, loading, error, refetch } = useFetch('/api/backorders?status=open');
  const { showToast, Toast } = useToast();
  const [confirm, setConfirm] = useState(null);

  const fulfill = async (id) => {
    try { await api.post(`/api/backorders/${id}/fulfill`); refetch(); showToast('Backorder fulfilled successfully'); } catch (err) { alert(errMsg(err)); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  return (
    <div>

      {confirm && <ConfirmDialog message={`Mark backorder as fulfilled?`} onConfirm={() => { fulfill(confirm); setConfirm(null); }} onCancel={() => setConfirm(null)} />}
      <div className="page-header"><h1>Backorders</h1></div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Product</th><th>SKU</th><th>Qty needed</th><th>Order</th><th>Channel</th><th>Created</th><th>Actions</th></tr></thead>
            <tbody>
              {(data || []).map(b => (
                <tr key={b.id}>
                  <td>{b.product_name || b.sku}</td>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>{b.sku}</td>
                  <td>{b.quantity_needed}</td>
                  <td style={{ fontSize:12 }}>{b.order_ref}</td>
                  <td><Badge status={b.channel || 'direct'} /></td>
                  <td style={{ fontSize:12 }}>{fmt.date(b.created_at)}</td>
                  <td>
                    <button className="btn btn-sm btn-primary" onClick={() => setConfirm(b.id)}>Fulfill</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(data||[]).length && <EmptyState icon="ti-clock-pause" message="No open backorders" />}
        </div>
      </div>
    </div>
  );
}
